<script lang="ts">
	import { setContext } from 'svelte';
	import '../app.css';

	let { children, data } = $props();

	setContext('env', data.env);
</script>

<main class=" scrollbar-gutter h-fit w-full sm:h-full">
	{@render children?.()}
</main>
